import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { versionHistoryService } from '../../services/versionHistoryService';
import type { ReleaseEntry, Visibility } from './whatsNewTypes';

const KEY = ['version-history'];
const MANAGE_KEY = ['version-history', 'manage'];

export function useReleases() {
  return useQuery({ queryKey: KEY, queryFn: () => versionHistoryService.list() });
}
export function useManagedReleases() {
  return useQuery({ queryKey: MANAGE_KEY, queryFn: () => versionHistoryService.listForManage() });
}
export function useReleaseMutations() {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: KEY });
    qc.invalidateQueries({ queryKey: MANAGE_KEY });
  };
  const create = useMutation({ mutationFn: (p: Omit<ReleaseEntry, 'id'>) => versionHistoryService.create(p), onSuccess: invalidate });
  const update = useMutation({ mutationFn: (a: { id: string; payload: Partial<ReleaseEntry> }) => versionHistoryService.update(a.id, a.payload), onSuccess: invalidate });
  const setVisibility = useMutation({ mutationFn: (a: { id: string; visibility: Visibility }) => versionHistoryService.setVisibility(a.id, a.visibility), onSuccess: invalidate });
  const remove = useMutation({ mutationFn: (id: string) => versionHistoryService.remove(id), onSuccess: invalidate });
  return { create, update, setVisibility, remove };
}
